var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { h, H as Host } from './core-6f498fd9.js';
import { A as AutoCloseHandler } from './auto-close-handler-253c0ad4.js';
export { A as AutoCloseHandler } from './auto-close-handler-253c0ad4.js';
import { P as Position, U as UuidService, a as PositionHandler } from './position-handler-48f35349.js';
export { U as UuidService } from './position-handler-48f35349.js';
import { f as flags } from './all-flags-c7c3ecfe.js';
import { u as useAttributesWatcher } from './useAttributesWatcher-63f5501f.js';
import { C as CsmOverlayType, a as CsmOverlayScrollStrategy } from './csm-overlay.constants-8ff0efb3.js';
export { a as CsmOverlayScrollStrategy, C as CsmOverlayType, c as csmOverlayBlockScrollId } from './csm-overlay.constants-8ff0efb3.js';
export { C as CsmOverlay } from './index-84f7f178.js';
import { C as CsmTableSortOrder } from './csm-table.constants-afa8d3aa.js';
export { C as CsmTableSortOrder } from './csm-table.constants-afa8d3aa.js';
import { T as TextfieldType } from './textfield.type-6ef76b70.js';
import { C as CsmToastSeverity, a as CsmToastClosingType } from './csm-toast.constants-1f59b2c9.js';
export { a as CsmToastClosingType, C as CsmToastSeverity } from './csm-toast.constants-1f59b2c9.js';
import { S as SpinnerSize } from './csm-spinner.constants-51c73f78.js';
var CsmActionItem = /** @class */ (function () {
    function CsmActionItem() {
    }
    CsmActionItem.prototype.connectedCallback = function () {
        this.text = this.host.textContent;
    };
    CsmActionItem.prototype.onClick = function (e) {
        e.cancelBubble = true;
        e.preventDefault();
        if (!this.disabled) {
            this.csmClick.emit(this);
        }
        else {
            this.csmDisabledItemClick.emit(this);
        }
    };
    CsmActionItem.prototype.render = function () {
        var _this = this;
        var isSemiBold = !!this.host.attributes.getNamedItem('semi-bold');
        var controls = [
            this.icon && h("csm-icon", { class: "csm-action-item__icon", name: this.icon }),
            h("csm-label", { class: "csm-action-item__label", "semi-bold": isSemiBold }, h("slot", null)),
            this.disabled && h("csm-icon", { class: "csm-action-item__lock", name: "lock" }),
        ];
        return h(Host, { onClick: function (e) { return _this.onClick(e); } }, controls);
    };
    Object.defineProperty(CsmActionItem, "is", {
        get: function () { return "csm-action-item"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionItem, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionItem, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-action-item.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionItem, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-action-item.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionItem, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": true
                },
                "text": {
                    "type": "string",
                    "mutable": true,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "text",
                    "reflect": false
                },
                "icon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "icon",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionItem, "events", {
        get: function () {
            return [{
                    "method": "csmClick",
                    "name": "csmClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmActionItem",
                        "resolved": "CsmActionItem",
                        "references": {
                            "CsmActionItem": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmDisabledItemClick",
                    "name": "csmDisabledItemClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmActionItem",
                        "resolved": "CsmActionItem",
                        "references": {
                            "CsmActionItem": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionItem, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmActionItem;
}());
var CsmActionList = /** @class */ (function () {
    function CsmActionList() {
        this.disabled = false;
        this.icon = 'more-horizontal';
        this.isOpen = false;
    }
    CsmActionList.prototype.open = function () {
        this.isOpen = true;
        this.csmOpen.emit(this);
    };
    CsmActionList.prototype.close = function () {
        this.isOpen = false;
        this.csmClose.emit(this);
    };
    CsmActionList.prototype.onItemSelected = function (_event) {
        this.close();
    };
    CsmActionList.prototype.componentDidLoad = function () {
        this.autoCloser = new AutoCloseHandler(this);
    };
    CsmActionList.prototype.componentDidRender = function () {
        var actionList = this.hostElement.shadowRoot.querySelector('csm-dropdown-list');
        if (!actionList) {
            return;
        }
        var hostDimension = this.hostElement.getBoundingClientRect();
        var actionListDimension = actionList.getBoundingClientRect();
        var hasTop = (document.body.clientHeight - actionListDimension.top - actionListDimension.height) >= 0;
        var hasBottom = (document.body.clientHeight - actionListDimension.top - actionListDimension.height) < 0;
        var hasLeft = (document.body.clientWidth - actionListDimension.left - actionListDimension.width) >= 0;
        var hasRight = (document.body.clientWidth - actionListDimension.left - actionListDimension.width) < 0;
        if (hasTop) {
            actionList.style.top = hostDimension.bottom + "px";
        }
        if (hasLeft) {
            actionList.style.left = hostDimension.left + "px";
        }
        if (hasRight) {
            actionList.style.left = hostDimension.left - actionListDimension.width + "px";
        }
        if (hasBottom) {
            actionList.style.top = hostDimension.top - actionListDimension.height + "px";
        }
    };
    CsmActionList.prototype.render = function () {
        var _this = this;
        var dropdown = (h("csm-dropdown-list", { class: "csm-action-list__dropdown-list" }, h("slot", null)));
        return (h(Host, { "data-is-open": this.isOpen }, h("div", { class: "csm-action-list" }, h("csm-button", { icon: this.icon, onCsmClick: function () { return _this.autoCloser.toggle(); }, "text-black": true, class: "csm-action-list__button" }), this.isOpen && dropdown)));
    };
    Object.defineProperty(CsmActionList, "is", {
        get: function () { return "csm-action-list"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-action-list.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-action-list.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "icon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "icon",
                    "reflect": false,
                    "defaultValue": "'more-horizontal'"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "states", {
        get: function () {
            return {
                "isOpen": {},
                "autoCloser": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "events", {
        get: function () {
            return [{
                    "method": "csmOpen",
                    "name": "csmOpen",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmActionList",
                        "resolved": "CsmActionList",
                        "references": {
                            "CsmActionList": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmClose",
                    "name": "csmClose",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmActionList",
                        "resolved": "CsmActionList",
                        "references": {
                            "CsmActionList": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmItemClick",
                    "name": "csmItemClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmActionItem",
                        "resolved": "CsmActionItem",
                        "references": {
                            "CsmActionItem": {
                                "location": "import",
                                "path": "./csm-action-item/csm-action-item"
                            }
                        }
                    }
                }, {
                    "method": "csmDisabledItemClick",
                    "name": "csmDisabledItemClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmActionItem",
                        "resolved": "CsmActionItem",
                        "references": {
                            "CsmActionItem": {
                                "location": "import",
                                "path": "./csm-action-item/csm-action-item"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "elementRef", {
        get: function () { return "hostElement"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmActionList, "listeners", {
        get: function () {
            return [{
                    "name": "csmItemClick",
                    "method": "onItemSelected",
                    "target": undefined,
                    "capture": false,
                    "passive": false
                }, {
                    "name": "csmDisabledItemClick",
                    "method": "onItemSelected",
                    "target": undefined,
                    "capture": false,
                    "passive": false
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmActionList;
}());
var CsmButton = /** @class */ (function () {
    function CsmButton() {
        var _this = this;
        this.disabled = false;
        this.icon = null;
        this.iconPosition = 'left';
        this.togglable = false;
        this.toggled = false;
        this.onClickHandler = function (event) {
            event.stopPropagation();
            if (_this.disabled) {
                return;
            }
            if (_this.togglable) {
                _this.toggled = !_this.toggled;
                _this.csmToggle.emit({
                    toggled: _this.toggled,
                });
            }
            _this.csmClick.emit(_this);
        };
    }
    CsmButton.prototype.render = function () {
        var controls = [
            this.icon && this.iconPosition === 'left' && (h("csm-icon", { class: "csm-button__container__icon-left", name: this.icon, "size-m": true })),
            this.hostElement.innerHTML && (h("span", { class: "csm-button__container__content" }, h("slot", null))),
            this.icon && this.iconPosition === 'right' && (h("csm-icon", { class: "csm-button__container__icon-right", name: this.icon, "size-m": true })),
        ];
        return (h("button", { class: {
                'csm-button__container': true,
                '--disabled': this.disabled,
                '--toggled': this.toggled,
            }, type: "button" // browser default is "submit"
            ,
            onClick: this.onClickHandler }, controls));
    };
    Object.defineProperty(CsmButton, "is", {
        get: function () { return "csm-button"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmButton, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmButton, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-button.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmButton, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-button.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmButton, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "icon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "icon",
                    "reflect": false,
                    "defaultValue": "null"
                },
                "iconPosition": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "'left' | 'right'",
                        "resolved": "\"left\" | \"right\"",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "icon-position",
                    "reflect": false,
                    "defaultValue": "'left'"
                },
                "togglable": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "togglable",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "toggled": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "toggled",
                    "reflect": false,
                    "defaultValue": "false"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmButton, "events", {
        get: function () {
            return [{
                    "method": "csmClick",
                    "name": "csmClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmButton",
                        "resolved": "CsmButton",
                        "references": {
                            "CsmButton": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmToggle",
                    "name": "csmToggle",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmButton, "elementRef", {
        get: function () { return "hostElement"; },
        enumerable: true,
        configurable: true
    });
    return CsmButton;
}());
var CsmCheckbox = /** @class */ (function () {
    function CsmCheckbox() {
        this.checked = false;
        this.disabled = false;
    }
    CsmCheckbox.prototype.onChange = function (event) {
        this.checked = event.target.checked;
        this.csmChange.emit({ checked: this.checked });
    };
    CsmCheckbox.prototype.onFocus = function () {
        this.csmFocus.emit();
    };
    CsmCheckbox.prototype.onBlur = function () {
        this.csmBlur.emit();
    };
    CsmCheckbox.prototype.render = function () {
        return (h("span", { class: "csm-checkbox__container" }, h("input", { class: "csm-checkbox", part: "checkbox", type: "checkbox", checked: this.checked, disabled: this.disabled, onMouseLeave: this.onBlur.bind(this), onMouseEnter: this.onFocus.bind(this), onChange: this.onChange.bind(this) }), h("csm-icon", { part: "checkbox-check", class: "csm-checkbox__check", name: "check", "size-s": true })));
    };
    Object.defineProperty(CsmCheckbox, "is", {
        get: function () { return "csm-checkbox"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCheckbox, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCheckbox, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-checkbox.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCheckbox, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-checkbox.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCheckbox, "properties", {
        get: function () {
            return {
                "checked": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "checked",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false,
                    "defaultValue": "false"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCheckbox, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }, {
                    "method": "csmFocus",
                    "name": "csmFocus",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }, {
                    "method": "csmBlur",
                    "name": "csmBlur",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmCheckbox;
}());
var CsmCollapsible = /** @class */ (function () {
    function CsmCollapsible() {
        this.open = false;
        this.summary = '';
    }
    CsmCollapsible.prototype.componentDidLoad = function () {
        this.detailsElement.addEventListener('toggle', this.onChange.bind(this));
    };
    CsmCollapsible.prototype.componentDidUnload = function () {
        this.detailsElement.removeEventListener('toggle', this.onChange.bind(this));
    };
    CsmCollapsible.prototype.onChange = function () {
        this.open = this.detailsElement.open;
        this.csmChange.emit({ open: this.detailsElement.open });
    };
    ;
    CsmCollapsible.prototype.render = function () {
        var _this = this;
        var open = this.detailsElement ? this.detailsElement.open : this.open;
        return (h("details", { open: open, ref: function (el) { return _this.detailsElement = el; } }, h("summary", null, h("csm-label", { "semi-bold": true }, this.summary), h("csm-icon", { name: open ? 'angle-top' : 'angle-down', "size-l": true })), h("div", { class: "content" }, h("slot", null))));
    };
    Object.defineProperty(CsmCollapsible, "is", {
        get: function () { return "csm-collapsible"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCollapsible, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCollapsible, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-collapsible.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCollapsible, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-collapsible.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCollapsible, "properties", {
        get: function () {
            return {
                "open": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "open",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "summary": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "summary",
                    "reflect": false,
                    "defaultValue": "''"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmCollapsible, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmCollapsible;
}());
var CsmDropDownList = /** @class */ (function () {
    function CsmDropDownList() {
    }
    CsmDropDownList.prototype.onItemClick = function (ev) {
        ev.preventDefault();
        ev.cancelBubble = true;
        this.csmItemClick.emit(ev.detail);
    };
    CsmDropDownList.prototype.onScroll = function (event) {
        var el = (event.currentTarget || event.target);
        var reachBottom = el.scrollHeight - el.scrollTop - el.clientHeight < 1;
        this.csmScroll.emit({ reachBottom: reachBottom });
    };
    CsmDropDownList.prototype.render = function () {
        this.host.addEventListener('csmClick', this.onItemClick.bind(this));
        this.host.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        return (h(Host, { onClick: function (e) { return (e.cancelBubble = e.preventDefault()); } }, h("slot", null)));
    };
    Object.defineProperty(CsmDropDownList, "is", {
        get: function () { return "csm-dropdown-list"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDropDownList, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDropDownList, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-dropdown-list.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDropDownList, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-dropdown-list.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDropDownList, "events", {
        get: function () {
            return [{
                    "method": "csmItemClick",
                    "name": "csmItemClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmSelectItem | CsmActionItem",
                        "resolved": "CsmActionItem | CsmSelectItem",
                        "references": {
                            "CsmSelectItem": {
                                "location": "import",
                                "path": "../csm-select/csm-select-item/csm-select-item"
                            },
                            "CsmActionItem": {
                                "location": "import",
                                "path": "../csm-action-list/csm-action-item/csm-action-item"
                            }
                        }
                    }
                }, {
                    "method": "csmScroll",
                    "name": "csmScroll",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "{ reachBottom: boolean }",
                        "resolved": "{ reachBottom: boolean; }",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDropDownList, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmDropDownList;
}());
var flagAliases = {
    uk: 'gb',
};
var CsmIcon = /** @class */ (function () {
    function CsmIcon() {
    }
    CsmIcon.prototype.componentWillLoad = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, flagName, flag, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!((_a = this.name) === null || _a === void 0 ? void 0 : _a.startsWith('flag-'))) return [3 /*break*/, 2];
                        flagName = this.name.substring(5);
                        flagName = (_b = flagAliases[flagName], (_b !== null && _b !== void 0 ? _b : flagName));
                        flag = flags[flagName];
                        if (!flag) {
                            throw new Error('flag not found: ' + this.name);
                        }
                        _c = this;
                        return [4 /*yield*/, flag()];
                    case 1:
                        _c.flagIcon = _d.sent();
                        _d.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    CsmIcon.prototype.render = function () {
        var _c;
        if (this.flagIcon) {
            return this.flagIcon;
        }
        var classValues = (_c = {}, _c['cs-' + this.name] = true, _c.centerer = true, _c);
        return h("span", { class: classValues });
    };
    Object.defineProperty(CsmIcon, "is", {
        get: function () { return "csm-icon"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIcon, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIcon, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-icon.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIcon, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-icon.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIcon, "properties", {
        get: function () {
            return {
                "name": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "name",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIcon, "states", {
        get: function () {
            return {
                "flagIcon": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmIcon;
}());
var Slot;
(function (Slot) {
    Slot["LeftIcon"] = "left-icon";
    Slot["RightIcon"] = "right-icon";
})(Slot || (Slot = {}));
var hasSlot = function (element) { return function (slotName) { return Boolean(element.querySelector("[slot=\"" + slotName + "\"]")); }; };
var toClass = function () { return function (slotName) { return "csm-input__input--with-" + slotName; }; };
var CsmInput = /** @class */ (function () {
    function CsmInput() {
        this.focusInput = this.focusInput.bind(this);
    }
    CsmInput.prototype.connectedCallback = function () {
        var _this = this;
        this.attributesWatcherDisconnect = useAttributesWatcher(this.host, function (attributes) {
            _this.attributes = attributes;
        });
    };
    CsmInput.prototype.disconnectedCallback = function () {
        if (this.attributesWatcherDisconnect) {
            this.attributesWatcherDisconnect();
            this.attributesWatcherDisconnect = null;
        }
    };
    CsmInput.prototype.focusInput = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.textInput.focus();
                return [2 /*return*/];
            });
        });
    };
    CsmInput.prototype.onFocus = function (event) {
        this.csmFocus.emit(event);
    };
    CsmInput.prototype.transformEvent = function (event) {
        event.value = this.textInput.value;
        return event;
    };
    CsmInput.prototype.getSlotClasses = function () {
        return Object.values(Slot)
            .filter(hasSlot(this.host))
            .map(toClass())
            .join(' ');
    };
    CsmInput.prototype.render = function () {
        var _this = this;
        return (h(Host, null, h("input", Object.assign({}, this.attributes, { ref: function (el) { return (_this.textInput = el); }, class: 'csm-input__input ' + this.getSlotClasses(), part: "input", onInput: function (event) { return _this.csmChange.emit(_this.transformEvent(event)); }, onBlur: function (event) { return _this.csmBlur.emit(_this.transformEvent(event)); }, onFocus: function (event) { return _this.csmFocus.emit(_this.transformEvent(event)); } })), h("slot", { name: Slot.LeftIcon }), h("slot", { name: Slot.RightIcon })));
    };
    Object.defineProperty(CsmInput, "is", {
        get: function () { return "csm-input"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-input.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-input.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "states", {
        get: function () {
            return {
                "attributes": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "InputEvent",
                        "resolved": "InputEvent",
                        "references": {
                            "InputEvent": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmFocus",
                    "name": "csmFocus",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "FocusEvent",
                        "resolved": "FocusEvent",
                        "references": {
                            "FocusEvent": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmBlur",
                    "name": "csmBlur",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "FocusEvent",
                        "resolved": "FocusEvent",
                        "references": {
                            "FocusEvent": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "methods", {
        get: function () {
            return {
                "focusInput": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "",
                        "tags": []
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmInput, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmInput;
}());
var CsmIntersectAnchor = /** @class */ (function () {
    function CsmIntersectAnchor() {
    }
    CsmIntersectAnchor.prototype.componentWillLoad = function () {
        var _this = this;
        this.anchorObserver = new IntersectionObserver(function (changes) { return _this.csmIntersectChange.emit(changes); }, this.options);
    };
    CsmIntersectAnchor.prototype.componentDidLoad = function () {
        this.anchorObserver.observe(this.element);
    };
    CsmIntersectAnchor.prototype.componentDidUnload = function () {
        this.anchorObserver.unobserve(this.element);
    };
    Object.defineProperty(CsmIntersectAnchor, "is", {
        get: function () { return "csm-intersect-anchor"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIntersectAnchor, "properties", {
        get: function () {
            return {
                "options": {
                    "type": "unknown",
                    "mutable": false,
                    "complexType": {
                        "original": "IntersectionObserverInit",
                        "resolved": "IntersectionObserverInit",
                        "references": {
                            "IntersectionObserverInit": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define the options for the IntersectionObserver"
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIntersectAnchor, "events", {
        get: function () {
            return [{
                    "method": "csmIntersectChange",
                    "name": "csmIntersectChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": "Triggered whenever an intersection is detected. Sends the array of intersections detected."
                    },
                    "complexType": {
                        "original": "Array<IntersectionObserverEntry>",
                        "resolved": "IntersectionObserverEntry[]",
                        "references": {
                            "Array": {
                                "location": "global"
                            },
                            "IntersectionObserverEntry": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmIntersectAnchor, "elementRef", {
        get: function () { return "element"; },
        enumerable: true,
        configurable: true
    });
    return CsmIntersectAnchor;
}());
var CsmLabel = /** @class */ (function () {
    function CsmLabel() {
    }
    CsmLabel.prototype.render = function () {
        return (h("span", null, h("slot", null)));
    };
    Object.defineProperty(CsmLabel, "is", {
        get: function () { return "csm-label"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmLabel, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmLabel, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-label.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmLabel, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-label.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmLabel;
}());
var CsmPagination = /** @class */ (function () {
    function CsmPagination() {
        var _this = this;
        /**
         * Option to display or result per page choice
         */
        this.displayResultPerPage = false;
        /**
         * Option to hide pagination numbers
         */
        this.hidePaginationNumbers = false;
        /**
         *
         */
        this.resultPerPage = 10;
        /**
         * Text label for "results per page"
         */
        this.resultPerPageLabel = 'results per page';
        this.resultPerPageValues = [10, 50, 100];
        this.generatePagination = function () {
            var radius = (_this.pageDisplayed - 1) / 2;
            var values = [];
            var buttonValues = [];
            for (var idx = 1; idx <= _this.pageCount; idx++) {
                if (idx === 1 || idx === _this.pageCount) {
                    values.push(idx);
                }
                else if (idx <= _this.pageDisplayed && _this.page <= _this.pageDisplayed - 1) {
                    values.push(idx);
                }
                else if (idx > _this.pageCount - _this.pageDisplayed && _this.page > _this.pageCount - (_this.pageDisplayed - 1)) {
                    values.push(idx);
                }
                else if (_this.page > _this.pageDisplayed - 1 &&
                    _this.page <= _this.pageCount - (_this.pageDisplayed - 1) &&
                    idx < _this.page + radius + 1 &&
                    idx >= _this.page - radius) {
                    values.push(idx);
                }
            }
            var lastValue;
            for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                var value = values_1[_i];
                if (lastValue && value - lastValue !== 1) {
                    buttonValues.push(null);
                }
                buttonValues.push(value);
                lastValue = value;
            }
            return buttonValues;
        };
        this.onPageSelectHandler = function (page) {
            _this.csmPageSelect.emit({ page: page });
        };
        this.onResultPerPageSelectHandler = function (resultPerPage) {
            _this.csmResultPerPageSelect.emit({ resultPerPage: resultPerPage });
        };
    }
    CsmPagination.prototype.render = function () {
        var _this = this;
        // Results per page
        var resultPerPageLinks = [].concat.apply([], this.resultPerPageValues.map(function (value, index) {
            var elements = [];
            if (value === _this.resultPerPage) {
                elements.push(h("span", { class: "result-per-page__value --selected" }, value));
            }
            else {
                elements.push(h("span", { class: "result-per-page__value", onClick: function () { return _this.onResultPerPageSelectHandler(value); } }, value));
            }
            if (index != _this.resultPerPageValues.length - 1) {
                elements.push(h("span", null, ", "));
            }
            return elements;
        }));
        // Pagination
        var values = this.generatePagination();
        var paginationButtons = !this.hidePaginationNumbers
            ? values.map(function (value) {
                if (value === _this.page) {
                    //@ts-ignore
                    return h("csm-button", { secondary: true }, value);
                }
                else if (value === null) {
                    return (
                    //@ts-ignore
                    h("csm-button", { tertiary: true, disabled: true }, "..."));
                }
                else {
                    return (
                    //@ts-ignore
                    h("csm-button", { onCsmClick: function () { return _this.onPageSelectHandler(value); }, tertiary: true }, value));
                }
            })
            : [];
        return (h("div", null, this.displayResultPerPage && (h("span", { class: "result-per-page" }, resultPerPageLinks, h("span", null, " ", this.resultPerPageLabel))), this.page <= 1 ? (
        //@ts-ignore
        h("csm-button", { tertiary: true, disabled: true, icon: "arrow-left" })) : (
        //@ts-ignore
        h("csm-button", {
            //@ts-ignore
            tertiary: true, onCsmClick: function () { return _this.onPageSelectHandler(_this.page - 1); }, icon: "arrow-left"
        })), paginationButtons, this.page >= this.pageCount ? (
        //@ts-ignore
        h("csm-button", { tertiary: true, disabled: true, icon: "arrow-right" })) : (
        //@ts-ignore
        h("csm-button", {
            //@ts-ignore
            tertiary: true, onCsmClick: function () { return _this.onPageSelectHandler(_this.page + 1); }, icon: "arrow-right"
        }))));
    };
    Object.defineProperty(CsmPagination, "is", {
        get: function () { return "csm-pagination"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPagination, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPagination, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-pagination.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPagination, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-pagination.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPagination, "properties", {
        get: function () {
            return {
                "page": {
                    "type": "number",
                    "mutable": true,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Current page number."
                    },
                    "attribute": "page",
                    "reflect": false
                },
                "pageCount": {
                    "type": "number",
                    "mutable": true,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Number of pages expected (correspond to the last page number)."
                    },
                    "attribute": "page-count",
                    "reflect": false
                },
                "pageDisplayed": {
                    "type": "number",
                    "mutable": true,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Number of page buttons to display between first and last page (has to be odd)."
                    },
                    "attribute": "page-displayed",
                    "reflect": false
                },
                "displayResultPerPage": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Option to display or result per page choice"
                    },
                    "attribute": "display-result-per-page",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "hidePaginationNumbers": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Option to hide pagination numbers"
                    },
                    "attribute": "hide-pagination-numbers",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "resultPerPage": {
                    "type": "number",
                    "mutable": true,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "result-per-page",
                    "reflect": false,
                    "defaultValue": "10"
                },
                "resultPerPageLabel": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Text label for \"results per page\""
                    },
                    "attribute": "result-per-page-label",
                    "reflect": false,
                    "defaultValue": "'results per page'"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPagination, "events", {
        get: function () {
            return [{
                    "method": "csmPageSelect",
                    "name": "csmPageSelect",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": "Triggered when a pagination button is clicked. Contains the page number clicked."
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }, {
                    "method": "csmResultPerPageSelect",
                    "name": "csmResultPerPageSelect",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": "Triggered when a number of result per page is selected. Contains the result per page number clicked."
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmPagination;
}());
var CsmPanel = /** @class */ (function () {
    function CsmPanel() {
        /**
         * Controls the type of overlay
         */
        this.overlayType = CsmOverlayType.Light;
        /**
         * Controls the scroll strategy
         */
        this.overlayScrollStrategy = CsmOverlayScrollStrategy.None;
        /**
         * Set whether the panel can be dismissed by clicking on the overlay
         */
        this.dismissOnOverlayClick = true;
        /**
         * Sets whether the overlay should close on ESC keyboard press
         */
        this.dismissOnEscape = true;
        /**
         * Reflects the state of the panel.
         */
        this.isOpen = false;
    }
    /**
     * Open the panel. <br/>
     * The method is async, but you can safely ignore the promise.
     */
    CsmPanel.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.isOpen = true;
                this.overlayRef.active = true;
                return [2 /*return*/];
            });
        });
    };
    /**
     * Close the panel. <br/>
     * The method is async, but you can safely ignore the promise.
     */
    CsmPanel.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.overlayRef.active = false;
                this.isOpen = false;
                this.csmDismiss.emit();
                this.csmClose.emit();
                return [2 /*return*/];
            });
        });
    };
    CsmPanel.prototype.componentDidLoad = function () {
        this.overlayRef = this.panelRef.shadowRoot.querySelector('.panel__overlay');
        this.contentElement = this.panelRef.children[0];
        this.closeButton = this.panelRef.shadowRoot.querySelector('.panel__close');
    };
    CsmPanel.prototype.componentDidUnload = function () {
        this.close();
    };
    CsmPanel.prototype.overlayDismiss = function (event) {
        if (this.dismissOnOverlayClick && event.target === this.overlayRef) {
            this.close();
        }
    };
    CsmPanel.prototype.render = function () {
        var _this = this;
        return (h("div", null, h("csm-overlay", { "scroll-strategy": this.overlayScrollStrategy, type: this.overlayType, "dismiss-on-escape": this.dismissOnEscape, class: { panel__overlay: true, 'panel__overlay--active': this.isOpen }, onClick: function (e) { return _this.overlayDismiss(e); }, onCsmOverlayClose: function () { return _this.close(); } }), h("div", { class: { panel: true, 'panel--open': this.isOpen } }, h("aside", { class: "panel__close-wrapper" }, h("button", { class: "panel__close", onClick: function () { return _this.close(); } }, h("csm-icon", { name: "close", "size-l": true }))), h("section", { class: "panel__content" }, h("slot", null)))));
    };
    Object.defineProperty(CsmPanel, "is", {
        get: function () { return "csm-panel"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-panel.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-panel.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "properties", {
        get: function () {
            return {
                "overlayType": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "CsmOverlayType",
                        "resolved": "CsmOverlayType.Dark | CsmOverlayType.DarkStrong | CsmOverlayType.Light | CsmOverlayType.LightStrong",
                        "references": {
                            "CsmOverlayType": {
                                "location": "import",
                                "path": "../csm-overlay"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Controls the type of overlay"
                    },
                    "attribute": "overlay-type",
                    "reflect": true,
                    "defaultValue": "CsmOverlayType.Light"
                },
                "overlayScrollStrategy": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "CsmOverlayScrollStrategy",
                        "resolved": "CsmOverlayScrollStrategy.Block | CsmOverlayScrollStrategy.Close | CsmOverlayScrollStrategy.None",
                        "references": {
                            "CsmOverlayScrollStrategy": {
                                "location": "import",
                                "path": "../csm-overlay"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Controls the scroll strategy"
                    },
                    "attribute": "overlay-scroll-strategy",
                    "reflect": true,
                    "defaultValue": "CsmOverlayScrollStrategy.None"
                },
                "dismissOnOverlayClick": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Set whether the panel can be dismissed by clicking on the overlay"
                    },
                    "attribute": "dismiss-on-overlay-click",
                    "reflect": false,
                    "defaultValue": "true"
                },
                "dismissOnEscape": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Sets whether the overlay should close on ESC keyboard press"
                    },
                    "attribute": "dismiss-on-escape",
                    "reflect": false,
                    "defaultValue": "true"
                },
                "isOpen": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Reflects the state of the panel."
                    },
                    "attribute": "is-open",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "contentElement": {
                    "type": "unknown",
                    "mutable": true,
                    "complexType": {
                        "original": "HTMLElement",
                        "resolved": "HTMLElement",
                        "references": {
                            "HTMLElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    }
                },
                "closeButton": {
                    "type": "unknown",
                    "mutable": true,
                    "complexType": {
                        "original": "HTMLElement",
                        "resolved": "HTMLElement",
                        "references": {
                            "HTMLElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "events", {
        get: function () {
            return [{
                    "method": "csmDismiss",
                    "name": "csmDismiss",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [{
                                "text": "Deprecated in favor of csmClose <br />\nSent whenever the panel is closed through its `close()` method",
                                "name": "deprecated"
                            }],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }, {
                    "method": "csmClose",
                    "name": "csmClose",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": "Sent whenever the panel is closed through its `close()` method"
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "methods", {
        get: function () {
            return {
                "open": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "Open the panel. <br/>\nThe method is async, but you can safely ignore the promise.",
                        "tags": []
                    }
                },
                "close": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "Close the panel. <br/>\nThe method is async, but you can safely ignore the promise.",
                        "tags": []
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPanel, "elementRef", {
        get: function () { return "panelRef"; },
        enumerable: true,
        configurable: true
    });
    return CsmPanel;
}());
var CsmPill = /** @class */ (function () {
    function CsmPill() {
        this.disabled = false;
        this.size = 'medium';
        this.type = 'chip';
    }
    CsmPill.prototype.onIconClick = function (event, clickedIcon) {
        event.stopPropagation();
        this.csmIconClick.emit({ clickedIcon: clickedIcon });
    };
    CsmPill.prototype.render = function () {
        var _this = this;
        var clickable = this.type === 'chip' && !this.disabled;
        var LeftIcon = function () {
            return (h("csm-icon", { onClick: function (e) { return clickable && _this.onIconClick(e, 'left'); }, class: "csm-pill__icon csm-pill__icon--left", name: _this.leftIcon, part: "left-icon" }));
        };
        var RightIcon = function () {
            return (h("csm-icon", { onClick: function (e) { return clickable && _this.onIconClick(e, 'right'); }, class: "csm-pill__icon csm-pill__icon--right", name: _this.rightIcon, part: "right-icon" }));
        };
        return (h("span", { class: "csm-pill", part: "pill", onClick: function (e) { return clickable && _this.csmClick.emit(e); } }, this.leftIcon && h(LeftIcon, null), h("span", { class: "csm-pill__content" }, h("slot", null)), this.rightIcon && h(RightIcon, null)));
    };
    Object.defineProperty(CsmPill, "is", {
        get: function () { return "csm-pill"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPill, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPill, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-pill.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPill, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-pill.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPill, "properties", {
        get: function () {
            return {
                "leftIcon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "left-icon",
                    "reflect": false
                },
                "rightIcon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "right-icon",
                    "reflect": false
                },
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "size": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "'extra-small' | 'small' | 'medium' | 'large'",
                        "resolved": "\"extra-small\" | \"large\" | \"medium\" | \"small\"",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "size",
                    "reflect": true,
                    "defaultValue": "'medium'"
                },
                "type": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "'chip' | 'label' | 'metrics' | 'status'",
                        "resolved": "\"chip\" | \"label\" | \"metrics\" | \"status\"",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "type",
                    "reflect": true,
                    "defaultValue": "'chip'"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmPill, "events", {
        get: function () {
            return [{
                    "method": "csmClick",
                    "name": "csmClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "MouseEvent",
                        "resolved": "MouseEvent",
                        "references": {
                            "MouseEvent": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmIconClick",
                    "name": "csmIconClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "{ clickedIcon: 'left' | 'right' }",
                        "resolved": "{ clickedIcon: \"left\" | \"right\"; }",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmPill;
}());
var Mode;
(function (Mode) {
    Mode[Mode["SINGLE_VALUE"] = 1] = "SINGLE_VALUE";
    Mode[Mode["RANGE_VALUE"] = 2] = "RANGE_VALUE";
})(Mode || (Mode = {}));
var CsmRangeSlider = /** @class */ (function () {
    function CsmRangeSlider() {
        this.disabled = false;
        /**
         * The minimum value can no longer equal or exceed the maximum value
         */
        this.nocrossover = false;
        this.updateHighlightNeeded = false;
    }
    CsmRangeSlider.prototype.valueUpdate = function (value) {
        this.buffer = undefined;
        this.setMode(value);
    };
    CsmRangeSlider.prototype.setMode = function (value) {
        this.mode = isNaN(Number(value)) ? Mode.RANGE_VALUE : Mode.SINGLE_VALUE;
        if (this.mode === Mode.RANGE_VALUE) {
            this.updateHighlightNeeded = true;
        }
    };
    CsmRangeSlider.prototype.onValueChange = function (event) {
        this.value = event.target.value;
        this.csmChange.emit({ value: this.value });
    };
    CsmRangeSlider.prototype.onRangeValueChange = function () {
        this.value = this.getMinMaxSliderValue();
        this.csmChange.emit(Object.assign({}, this.value));
    };
    CsmRangeSlider.prototype.updateSliderHighlight = function () {
        var value = this.getMinMaxSliderValue();
        var _c = this.getInputsElement(), firstInput = _c.firstInput, secondInput = _c.secondInput;
        if (firstInput && secondInput) {
            secondInput.style.setProperty('--low', 100 * ((value.min - this.min) / (this.max - this.min)) + 1 + '%');
            secondInput.style.setProperty('--high', 100 * ((value.max - this.min) / (this.max - this.min)) - 1 + '%');
        }
        this.csmDrag.emit(Object.assign({}, value));
    };
    CsmRangeSlider.prototype.getMinMaxSliderValue = function () {
        var _c = this.getInputsElement(), firstInput = _c.firstInput, secondInput = _c.secondInput;
        if (firstInput && secondInput) {
            if (this.nocrossover) {
                if (this.buffer === undefined) {
                    this.buffer = {
                        min: +firstInput.value || 0,
                        max: +secondInput.value || 0,
                    };
                }
                if (+firstInput.value >= this.buffer.max) {
                    firstInput.value = (+this.buffer.max - +this.step).toString();
                }
                if (+secondInput.value <= this.buffer.min) {
                    secondInput.value = (+this.buffer.min + +this.step).toString();
                }
                return (this.buffer = {
                    min: +firstInput.value,
                    max: +secondInput.value,
                });
            }
            var minValue = Math.min(+firstInput.value, +secondInput.value);
            var maxValue = Math.max(+firstInput.value, +secondInput.value);
            return {
                min: minValue,
                max: maxValue,
            };
        }
    };
    CsmRangeSlider.prototype.getInputsElement = function () {
        var firstInput = this.element.shadowRoot.querySelector('input.csm-range-slider__range-value--first-range');
        var secondInput = this.element.shadowRoot.querySelector('input.csm-range-slider__range-value--second-range');
        return {
            firstInput: firstInput,
            secondInput: secondInput,
        };
    };
    CsmRangeSlider.prototype.componentDidUpdate = function () {
        if (this.updateHighlightNeeded) {
            this.updateSliderHighlight();
            this.updateHighlightNeeded = false;
        }
    };
    CsmRangeSlider.prototype.componentDidRender = function () {
        this.setMode(this.value);
        if (this.mode === Mode.RANGE_VALUE) {
            this.updateSliderHighlight();
        }
    };
    CsmRangeSlider.prototype.render = function () {
        var input = this.mode === Mode.RANGE_VALUE ? ([
            h("input", { type: "range", class: "csm-range-slider__range-value--first-range", onChange: this.onRangeValueChange.bind(this), onInput: this.updateSliderHighlight.bind(this), min: this.min, max: this.max, value: this.value.min, step: this.step }),
            h("input", { type: "range", class: "csm-range-slider__range-value--second-range", onChange: this.onRangeValueChange.bind(this), onInput: this.updateSliderHighlight.bind(this), min: this.min, max: this.max, value: this.value.max, step: this.step }),
        ]) : (h("input", { class: "csm-range-slider__single-value", onChange: this.onValueChange.bind(this), min: this.min, max: this.max, value: this.value, step: this.step, type: "range" }));
        return h(Host, null, input);
    };
    Object.defineProperty(CsmRangeSlider, "is", {
        get: function () { return "csm-range-slider"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-range-slider.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-range-slider.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "value": {
                    "type": "number",
                    "mutable": true,
                    "complexType": {
                        "original": "CsmRangeValue | number",
                        "resolved": "CsmRangeValue | number",
                        "references": {
                            "CsmRangeValue": {
                                "location": "import",
                                "path": "./csm-range-slider.contants"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "value",
                    "reflect": true
                },
                "min": {
                    "type": "number",
                    "mutable": false,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "min",
                    "reflect": false
                },
                "max": {
                    "type": "number",
                    "mutable": false,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "max",
                    "reflect": false
                },
                "step": {
                    "type": "number",
                    "mutable": false,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "step",
                    "reflect": false
                },
                "nocrossover": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "The minimum value can no longer equal or exceed the maximum value"
                    },
                    "attribute": "nocrossover",
                    "reflect": false,
                    "defaultValue": "false"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "states", {
        get: function () {
            return {
                "mode": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmRangeValue | { value: number }",
                        "resolved": "CsmRangeValue | { value: number; }",
                        "references": {
                            "CsmRangeValue": {
                                "location": "import",
                                "path": "./csm-range-slider.contants"
                            }
                        }
                    }
                }, {
                    "method": "csmDrag",
                    "name": "csmDrag",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmRangeValue | { value: number }",
                        "resolved": "CsmRangeValue | { value: number; }",
                        "references": {
                            "CsmRangeValue": {
                                "location": "import",
                                "path": "./csm-range-slider.contants"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "elementRef", {
        get: function () { return "element"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmRangeSlider, "watchers", {
        get: function () {
            return [{
                    "propName": "value",
                    "methodName": "valueUpdate"
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmRangeSlider;
}());
var CsmSelect = /** @class */ (function () {
    function CsmSelect() {
        this.value = null;
    }
    CsmSelect.prototype.open = function () {
        this.isOpen = true;
        setTimeout(this.scrolToDropdown.bind(this), 100);
    };
    CsmSelect.prototype.close = function () {
        var _this = this;
        setTimeout(function () { return (_this.isOpen = false); });
    };
    CsmSelect.prototype.scrolToDropdown = function () {
        if (this.dropdown) {
            this.dropdown.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
    };
    CsmSelect.prototype.onToggle = function () {
        var shouldOpen = !this.disabled && !this.isOpen;
        if (shouldOpen) {
            this.open();
        }
        else {
            this.close();
        }
    };
    CsmSelect.prototype.onItemSelected = function (e) {
        this.changeItem(e.detail.host);
    };
    CsmSelect.prototype.changeItem = function (item) {
        if (this.selectedItem) {
            this.selectedItem.selected = false;
            this.selectedItem = undefined;
        }
        if (item) {
            this.value = item.value;
            this.selectedItem = item;
            this.selectedItem.selected = true;
            this.close();
            this.csmChange.emit(item.value);
        }
        else {
            this.value = undefined;
        }
    };
    CsmSelect.prototype.componentDidUpdate = function () { };
    CsmSelect.prototype.componentWillLoad = function () {
        this.options = __spreadArrays(this.host.querySelectorAll('csm-select-item'));
        this.selectedItem = this.options.find(function (i) { return i.selected; });
        this.value = this.selectedItem && this.selectedItem.value;
    };
    CsmSelect.prototype.componentDidRender = function () {
        if (this.selectedItem) {
            var dropdown = this.selectedItem.parentElement.shadowRoot.querySelector('csm-dropdown-list');
            if (dropdown) {
                dropdown.scrollTop = this.selectedItem.offsetTop - 40;
            }
        }
    };
    CsmSelect.prototype.render = function () {
        var _this = this;
        var displayValue = this.selectedItem && (this.selectedItem.text || this.selectedItem.textContent);
        var elements = [
            h("csm-overlay", { active: this.isOpen, onClick: this.close.bind(this), onCsmOverlayClose: function (e) { return e.stopPropagation(); } }),
            h("input", Object.assign({ part: "csm-select-input", class: "csm-select__input " + (!displayValue ? '' : 'active'), placeholder: this.placeholder, type: "text", value: displayValue }, { disabled: !this.searchable || this.disabled })),
            this.searchable && h("csm-icon", { class: "csm-select__icon csm-select__icon-left", "size-m": true, name: "search" }),
            h("csm-icon", { class: "csm-select__icon csm-select__icon-right", "size-m": true, name: "angle-down", onClick: function () { return _this.onToggle(); } }),
            this.isOpen && h("br", null),
            h("csm-dropdown-list", { style: this.isOpen ? {} : { display: 'none' }, class: "csm-select__dropdown", ref: function (el) {
                    if (el) {
                        _this.dropdown = el;
                    }
                }, onCsmItemClick: function (e) { return _this.onItemSelected(e); } }, h("slot", null)),
        ];
        var classes = "csm-select " + (this.isOpen ? ' open' : '');
        var element = (h(Host, { class: classes, onClick: function () { return _this.onToggle(); } }, elements));
        var host = this.host;
        try {
            Object.defineProperty(host, 'value', {
                get: function () {
                    return _this.value;
                },
                set: function (newValue) {
                    if (newValue == null) {
                        _this.changeItem(null);
                        return;
                    }
                    var selectedItem = [].filter.apply(host.children, [function (i) { return i.value === newValue; }])[0];
                    if (!selectedItem) {
                        throw new Error('Option value not found: ' + newValue);
                    }
                    _this.changeItem(selectedItem);
                },
            });
        }
        catch (e) { }
        return element;
    };
    Object.defineProperty(CsmSelect, "is", {
        get: function () { return "csm-select"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-select.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-select.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": true
                },
                "searchable": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "searchable",
                    "reflect": false
                },
                "placeholder": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "placeholder",
                    "reflect": false
                },
                "value": {
                    "type": "string",
                    "mutable": true,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "value",
                    "reflect": false,
                    "defaultValue": "null"
                },
                "selectedItem": {
                    "type": "any",
                    "mutable": true,
                    "complexType": {
                        "original": "HTMLCsmSelectItemElement",
                        "resolved": "any",
                        "references": {
                            "HTMLCsmSelectItemElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "selected-item",
                    "reflect": false
                },
                "isOpen": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "is-open",
                    "reflect": false
                },
                "options": {
                    "type": "unknown",
                    "mutable": false,
                    "complexType": {
                        "original": "HTMLCsmSelectItemElement[]",
                        "resolved": "any[]",
                        "references": {
                            "HTMLCsmSelectItemElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelect, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmSelect;
}());
var CsmSelectCategory = /** @class */ (function () {
    function CsmSelectCategory() {
    }
    CsmSelectCategory.prototype.render = function () {
        return (h(Host, { onClick: function (e) { return (e.cancelBubble = true); } }, h("csm-label", null, h("slot", null))));
    };
    Object.defineProperty(CsmSelectCategory, "is", {
        get: function () { return "csm-select-category"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectCategory, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectCategory, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-select-category.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectCategory, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-select-category.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmSelectCategory;
}());
var CsmSelectDivider = /** @class */ (function () {
    function CsmSelectDivider() {
    }
    CsmSelectDivider.prototype.render = function () {
        return (h(Host, { onClick: function (e) { return (e.cancelBubble = true); } }, h("slot", null)));
    };
    Object.defineProperty(CsmSelectDivider, "is", {
        get: function () { return "csm-select-divider"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectDivider, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectDivider, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-select-divider.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectDivider, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-select-divider.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmSelectDivider;
}());
var CsmSelectItem = /** @class */ (function () {
    function CsmSelectItem() {
    }
    CsmSelectItem.prototype.componentDidRender = function () {
        this.selected = !!this.selected;
        this.disabled = !!this.disabled;
        this.text = this.text || this.host.innerText;
        this.leftIconElement = this.host.shadowRoot.querySelector('csm-icon.csm-select-item__icon-left');
        this.rightIconElement = this.host.shadowRoot.querySelector('csm-icon.csm-select-item__icon-right');
    };
    CsmSelectItem.prototype.onClick = function (e) {
        e.cancelBubble = true;
        e.preventDefault();
        if (this.disabled) {
            return;
        }
        this.csmClick.emit(this);
    };
    CsmSelectItem.prototype.scrollIntoView = function () {
        var dropdown = this.host.parentElement.shadowRoot.querySelector('csm-dropdown-list');
        if (dropdown) {
            dropdown.scrollTop = this.host.offsetTop - 40;
        }
    };
    CsmSelectItem.prototype.render = function () {
        var _this = this;
        var isSemiBold = !!this.host.attributes.getNamedItem('semi-bold');
        var selectedClass = this.selected ? "selected" : '';
        var controls = [
            this.useMarker && h("span", { class: 'csm-select-item__marker' }),
            this.leftIcon && (h("csm-icon", { class: "csm-select-item__icon csm-select-item__icon-left", name: this.leftIcon })),
            h("csm-label", { class: "csm-select-item__text", "semi-bold": isSemiBold }, h("slot", null)),
            this.rightIcon && (h("csm-icon", { class: "csm-select-item__icon csm-select-item__icon-right", name: this.rightIcon })),
            this.rightText && h("csm-label", { class: "csm-select-item__text-right" }, this.rightText),
        ];
        return (h(Host, { class: selectedClass, onClick: function (e) { return _this.onClick(e); } }, controls));
    };
    Object.defineProperty(CsmSelectItem, "is", {
        get: function () { return "csm-select-item"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectItem, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectItem, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-select-item.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectItem, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-select-item.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectItem, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": true
                },
                "value": {
                    "type": "string",
                    "mutable": true,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "value",
                    "reflect": true
                },
                "leftIcon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "left-icon",
                    "reflect": false
                },
                "rightIcon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "right-icon",
                    "reflect": false
                },
                "rightText": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "right-text",
                    "reflect": false
                },
                "selected": {
                    "type": "boolean",
                    "mutable": true,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "selected",
                    "reflect": true
                },
                "useMarker": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "use-marker",
                    "reflect": false
                },
                "text": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "text",
                    "reflect": false
                },
                "rightIconElement": {
                    "type": "any",
                    "mutable": false,
                    "complexType": {
                        "original": "HTMLCsmIconElement",
                        "resolved": "any",
                        "references": {
                            "HTMLCsmIconElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "right-icon-element",
                    "reflect": false
                },
                "leftIconElement": {
                    "type": "any",
                    "mutable": false,
                    "complexType": {
                        "original": "HTMLCsmIconElement",
                        "resolved": "any",
                        "references": {
                            "HTMLCsmIconElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "left-icon-element",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectItem, "events", {
        get: function () {
            return [{
                    "method": "csmClick",
                    "name": "csmClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmSelectItem",
                        "resolved": "CsmSelectItem",
                        "references": {
                            "CsmSelectItem": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSelectItem, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmSelectItem;
}());
var CsmSortableList = /** @class */ (function () {
    function CsmSortableList() {
        this.sortedKeys = [];
    }
    CsmSortableList.prototype.onDropToUnselectedList = function (_c) {
        var detail = _c.detail;
        var keyIndex = this.sortedKeys.findIndex(function (key) { return key === detail.dropKey; });
        var list = keyIndex === -1 ? __spreadArrays(this.sortedKeys, [detail.dropKey]) : __spreadArrays(this.sortedKeys);
        var indexFrom = keyIndex === -1 ? list.length - 1 : keyIndex;
        var indexTo = +detail.indexTo;
        if (indexFrom === indexTo) {
            return;
        }
        var otherItems = __spreadArrays(list.slice(0, +indexFrom), list.slice(+indexFrom + 1));
        var dropItem = list[+indexFrom];
        var newDataKeys = __spreadArrays(otherItems.slice(0, indexTo), [dropItem], otherItems.slice(indexTo));
        if (newDataKeys.toString() !== this.sortedKeys.toString()) {
            this.csmSort.emit(newDataKeys);
        }
    };
    CsmSortableList.prototype.getItems = function () {
        var sortableItems = this.element.querySelectorAll('csm-sortable-item');
        if (!sortableItems || !sortableItems.length) {
            return null;
        }
        var items = {};
        Array.from(sortableItems).forEach(function (item) {
            var key = item.attributes['data-key'].value;
            items[key] = item;
        });
        return items;
    };
    CsmSortableList.prototype.componentDidRender = function () {
        var _this = this;
        if (this.sortedKeys && this.sortedKeys.length) {
            var sortableItems_1 = this.getItems();
            Object.keys(sortableItems_1).forEach(function (key) {
                if (_this.sortedKeys.indexOf(key) === -1) {
                    sortableItems_1[key].remove();
                }
            });
            this.sortedKeys.forEach(function (key) {
                _this.element.appendChild(sortableItems_1[key]);
            });
        }
    };
    CsmSortableList.prototype.render = function () {
        return (h(Host, { onCsmDrop: this.onDropToUnselectedList.bind(this) }, h("div", null, h("slot", null))));
    };
    Object.defineProperty(CsmSortableList, "is", {
        get: function () { return "csm-sortable-list"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableList, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-sortable-list.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableList, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-sortable-list.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableList, "properties", {
        get: function () {
            return {
                "sortedKeys": {
                    "type": "unknown",
                    "mutable": false,
                    "complexType": {
                        "original": "string[]",
                        "resolved": "string[]",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "defaultValue": "[]"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableList, "events", {
        get: function () {
            return [{
                    "method": "csmSort",
                    "name": "csmSort",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableList, "elementRef", {
        get: function () { return "element"; },
        enumerable: true,
        configurable: true
    });
    return CsmSortableList;
}());
var CsmDroppableArea = /** @class */ (function () {
    function CsmDroppableArea() {
    }
    CsmDroppableArea.prototype.componentDidLoad = function () {
        this.droppableElement.addEventListener('dragenter', this.onDragEnter.bind(this));
        this.maskElement.addEventListener('dragover', this.onDragOver.bind(this));
        this.maskElement.addEventListener('dragleave', this.onDragLeave.bind(this));
        this.maskElement.addEventListener('drop', this.onDrop.bind(this));
    };
    CsmDroppableArea.prototype.componentDidUnload = function () {
        this.droppableElement.removeEventListener('dragenter', this.onDragEnter.bind(this));
        this.maskElement.removeEventListener('dragover', this.onDragOver.bind(this));
        this.maskElement.removeEventListener('dragleave', this.onDragLeave.bind(this));
        this.maskElement.removeEventListener('drop', this.onDrop.bind(this));
    };
    CsmDroppableArea.prototype.onDragEnter = function (event) {
        console.log('onDragEnter');
        if (event.dataTransfer.types.includes('csm-dragndrop-type')) {
            // prevent the default handling by cancelling the event to allow a drop
            event.preventDefault();
            this.droppableElement.classList.add('is-dropping');
        }
    };
    CsmDroppableArea.prototype.onDragOver = function (event) {
        if (event.dataTransfer.types.includes('csm-dragndrop-type')) {
            // prevent the default handling by cancelling the event to allow a drop
            event.preventDefault();
        }
    };
    CsmDroppableArea.prototype.onDragLeave = function () {
        this.droppableElement.classList.remove('is-dropping');
    };
    CsmDroppableArea.prototype.onDrop = function (event) {
        // prevent the default handling by cancelling the event to allow a drop
        event.preventDefault();
        this.droppableElement.classList.remove('is-dropping');
        console.log(event.dataTransfer.getData('csm-dragndrop-type'));
        this.csmDroppableDrop.emit({
            draggedHTML: event.dataTransfer.getData('csm-dragndrop-type'),
            dropTarget: this.droppableElement,
        });
    };
    CsmDroppableArea.prototype.render = function () {
        var _this = this;
        return (h(Host, { group: this.group }, h("slot", null), h("div", { class: "mask", ref: function (el) { return (_this.maskElement = el); } })));
    };
    Object.defineProperty(CsmDroppableArea, "is", {
        get: function () { return "csm-droppable-area"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-droppable-area.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-droppable-area.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "properties", {
        get: function () {
            return {
                "group": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "group",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "events", {
        get: function () {
            return [{
                    "method": "csmDroppableDrop",
                    "name": "csmDroppableDrop",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmDroppableArea, "elementRef", {
        get: function () { return "droppableElement"; },
        enumerable: true,
        configurable: true
    });
    return CsmDroppableArea;
}());
var buildElement = function (htmlString) {
    var template = document.createElement('template');
    template.innerHTML = htmlString.trim();
    return template.content.firstChild;
};
var CsmSortableItem = /** @class */ (function () {
    function CsmSortableItem() {
    }
    CsmSortableItem.prototype.onDragStart = function (event) {
        event.dataTransfer.setData('csm-dragndrop-type', event.currentTarget.outerHTML);
        event.currentTarget.style.cursor = 'grabbing';
    };
    CsmSortableItem.prototype.onDragEnd = function (event) {
        if (event.dataTransfer.dropEffect !== 'none') {
            var draggableDropEvent = new CustomEvent('dragsucsess', {
                detail: { target: event.currentTarget },
            });
            event.currentTarget.dispatchEvent(draggableDropEvent);
        }
        event.currentTarget.style.cursor = '';
    };
    CsmSortableItem.prototype.addElementToParentTarget = function (_c) {
        var _d = _c.detail, draggedHTML = _d.draggedHTML, dropTarget = _d.dropTarget;
        var draggedElement = buildElement(draggedHTML);
        var dropTargetGroup = dropTarget.getAttribute('group');
        var dragGroup = draggedElement.getAttribute('group');
        var emitData = {
            indexTo: dragGroup === dropTargetGroup && draggedElement.dataset.index < this.sortableItem.dataset.index
                ? +this.sortableItem.dataset.index - 1
                : +this.sortableItem.dataset.index,
            dropKey: draggedElement.attributes['data-key'].value,
        };
        this.csmDrop.emit(emitData);
    };
    CsmSortableItem.prototype.render = function () {
        return (h(Host, { draggable: "true", group: this.group, onDragStart: this.onDragStart.bind(this), onDragEnd: this.onDragEnd.bind(this) }, h("csm-droppable-area", { group: this.group, onCsmDroppableDrop: this.addElementToParentTarget.bind(this) }), h("div", { class: "csm-sortable-item__content" }, h("slot", null), h("csm-icon", { name: "drag" }))));
    };
    Object.defineProperty(CsmSortableItem, "is", {
        get: function () { return "csm-sortable-item"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableItem, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableItem, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-sortable-item.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableItem, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-sortable-item.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableItem, "properties", {
        get: function () {
            return {
                "group": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "group",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableItem, "events", {
        get: function () {
            return [{
                    "method": "csmDrop",
                    "name": "csmDrop",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableItem, "elementRef", {
        get: function () { return "sortableItem"; },
        enumerable: true,
        configurable: true
    });
    return CsmSortableItem;
}());
var CsmSortableListDemo = /** @class */ (function () {
    function CsmSortableListDemo() {
        this.selectedItems = [
            { value: 'elementB', name: 'elementB' },
            { value: 'elementA', name: 'elementA' },
            { value: 'elementC', name: 'elementC' },
            { value: 'elementD', name: 'elementD' },
        ];
        this.unselectedItems = [
            { value: 'element2', name: 'element2' },
            { value: 'element3', name: 'element3' },
            { value: 'element1', name: 'element1' },
            { value: 'element4', name: 'element4' },
        ];
    }
    CsmSortableListDemo.prototype.removeFromSelectedItem = function (item) {
        var index = this.selectedItems.indexOf(item);
        if (index !== -1) {
            this.selectedItems.splice(index, 1);
        }
    };
    CsmSortableListDemo.prototype.removeFromUnselectedItem = function (item) {
        var index = this.unselectedItems.indexOf(item);
        if (index !== -1) {
            this.unselectedItems.splice(index, 1);
        }
    };
    CsmSortableListDemo.prototype.addToSelectedList = function (item, indexToInsert) {
        if (indexToInsert === void 0) { indexToInsert = 0; }
        if (item) {
            this.removeFromSelectedItem(item);
            this.removeFromUnselectedItem(item);
            this.selectedItems.splice(indexToInsert, 0, item);
        }
        this.selectedItems = __spreadArrays(this.selectedItems);
    };
    CsmSortableListDemo.prototype.sortSelectedList = function (event) {
        var _this = this;
        var keys = event.detail;
        this.selectedItems = keys.map(function (key) { return __spreadArrays(_this.selectedItems, _this.unselectedItems).find(function (item) { return item.value === key; }); });
        this.unselectedItems = this.unselectedItems.filter(function (item) { return keys.indexOf(item.value) === -1; });
    };
    CsmSortableListDemo.prototype.sortUnselectedList = function (event) {
        var _this = this;
        var keys = event.detail;
        this.unselectedItems = keys.map(function (key) { return __spreadArrays(_this.unselectedItems, _this.selectedItems).find(function (item) { return item.value === key; }); });
        this.selectedItems = this.selectedItems.filter(function (item) { return keys.indexOf(item.value) === -1; });
    };
    CsmSortableListDemo.prototype.addToUnselectedList = function (item, indexToInsert) {
        if (indexToInsert === void 0) { indexToInsert = 0; }
        if (item) {
            this.removeFromSelectedItem(item);
            this.removeFromUnselectedItem(item);
            this.unselectedItems.splice(indexToInsert, 0, item);
        }
        this.unselectedItems = __spreadArrays(this.unselectedItems);
    };
    CsmSortableListDemo.prototype.renderSortableItem = function (isSelected, onCheckboxChange, group) {
        var _this = this;
        return function (item, index) {
            return (h("csm-sortable-item", { key: "" + item.value, "data-key": "" + item.value, "data-selected": isSelected, "data-index": index, group: group }, h("csm-checkbox", { checked: isSelected, onCsmChange: onCheckboxChange.bind(_this, item) }), h("csm-label", null, item.name)));
        };
    };
    CsmSortableListDemo.prototype.render = function () {
        var selectedItemsKey = this.selectedItems.map(function (item) { return item.name; });
        var selectedItems = this.selectedItems.map(this.renderSortableItem(true, this.addToUnselectedList, selectedItemsKey.toString()));
        var unselectedItemsKey = this.unselectedItems.map(function (item) { return item.name; });
        var unselectedItems = this.unselectedItems.map(this.renderSortableItem(false, this.addToSelectedList, unselectedItemsKey.toString()));
        return (h("div", { style: { height: '426px', display: 'flex' } }, h("br", null), h("csm-sortable-list", { style: { minWidth: '250px', marginRight: '20px' }, sortedKeys: selectedItemsKey, onCsmSort: this.sortSelectedList.bind(this) }, selectedItems), h("br", null), h("csm-sortable-list", { style: { minWidth: '250px' }, sortedKeys: unselectedItemsKey, onCsmSort: this.sortUnselectedList.bind(this) }, unselectedItems)));
    };
    Object.defineProperty(CsmSortableListDemo, "is", {
        get: function () { return "csm-sortable-list-demo"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableListDemo, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableListDemo, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-sortable-list-demo.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableListDemo, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-sortable-list-demo.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSortableListDemo, "states", {
        get: function () {
            return {
                "selectedItems": {},
                "unselectedItems": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmSortableListDemo;
}());
var CsmSwitcher = /** @class */ (function () {
    function CsmSwitcher() {
        this.host.addEventListener('csmClick', this.onSelect.bind(this));
    }
    CsmSwitcher.prototype.onSelect = function (e) {
        if (this.selectedItem) {
            this.selectedItem.selected = false;
        }
        if (e.detail) {
            var _c = e.detail, host = _c.host, value = _c.value;
            this.value = value;
            this.selectedItem = host;
            this.selectedItem.selected = true;
            this.csmChange.emit(value);
        }
    };
    CsmSwitcher.prototype.componentWillLoad = function () {
        var options = __spreadArrays(this.host.querySelectorAll('csm-switcher-option'));
        this.selectedItem = options.find(function (item) { return item.selected; });
        this.value = this.selectedItem && this.selectedItem.value;
    };
    CsmSwitcher.prototype.render = function () {
        return (h(Host, null, h("slot", null)));
    };
    Object.defineProperty(CsmSwitcher, "is", {
        get: function () { return "csm-switcher"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-switcher.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-switcher.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false
                },
                "value": {
                    "type": "string",
                    "mutable": true,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "value",
                    "reflect": false
                },
                "selectedItem": {
                    "type": "any",
                    "mutable": true,
                    "complexType": {
                        "original": "HTMLCsmSwitcherOptionElement",
                        "resolved": "any",
                        "references": {
                            "HTMLCsmSwitcherOptionElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "selected-item",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcher, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmSwitcher;
}());
var CsmSwitcherButton = /** @class */ (function () {
    function CsmSwitcherButton() {
        this.disabled = false;
        this.onClickHandler = this.onClickHandler.bind(this);
    }
    CsmSwitcherButton.prototype.onClickHandler = function (event) {
        event.stopPropagation();
        !this.disabled && this.csmClick.emit(this);
    };
    CsmSwitcherButton.prototype.render = function () {
        return (h(Host, { onClick: this.onClickHandler }, h("slot", null)));
    };
    Object.defineProperty(CsmSwitcherButton, "is", {
        get: function () { return "csm-switcher-button"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherButton, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherButton, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-switcher-button.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherButton, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-switcher-button.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherButton, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false,
                    "defaultValue": "false"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherButton, "events", {
        get: function () {
            return [{
                    "method": "csmClick",
                    "name": "csmClick",
                    "bubbles": false,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmSwitcherButton",
                        "resolved": "CsmSwitcherButton",
                        "references": {
                            "CsmSwitcherButton": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmSwitcherButton;
}());
var CsmSwitcherOption = /** @class */ (function () {
    function CsmSwitcherOption() {
        this.selected = false;
        this.disabled = false;
        this.onClickHandler = this.onClickHandler.bind(this);
    }
    CsmSwitcherOption.prototype.onClickHandler = function (e) {
        if (this.disabled) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        this.csmClick.emit(this);
    };
    CsmSwitcherOption.prototype.render = function () {
        return (h(Host, { onClick: this.onClickHandler, class: this.selected ? 'selected' : '' }, h("slot", null)));
    };
    Object.defineProperty(CsmSwitcherOption, "is", {
        get: function () { return "csm-switcher-option"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherOption, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherOption, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-switcher-option.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherOption, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-switcher-option.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherOption, "properties", {
        get: function () {
            return {
                "value": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "value",
                    "reflect": false
                },
                "selected": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "selected",
                    "reflect": false,
                    "defaultValue": "false"
                },
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false,
                    "defaultValue": "false"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherOption, "events", {
        get: function () {
            return [{
                    "method": "csmClick",
                    "name": "csmClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmSwitcherOption",
                        "resolved": "CsmSwitcherOption",
                        "references": {
                            "CsmSwitcherOption": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSwitcherOption, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmSwitcherOption;
}());
var CsmTable = /** @class */ (function () {
    function CsmTable() {
    }
    CsmTable.prototype.trackWheel = function () {
        this.tackleScrollingShadow();
    };
    CsmTable.prototype.trackScroll = function () {
        this.tackleScrollingShadow();
    };
    CsmTable.prototype.render = function () {
        return [
            h("div", { class: "table" }, h("div", { class: "table-content" }, h("slot", null))),
        ];
    };
    CsmTable.prototype.tackleScrollingShadow = function () {
        var _this = this;
        if (!this.tick) {
            window.requestAnimationFrame(function () {
                var target = _this.table;
                if (target.scrollLeft > 0) {
                    _this.table.classList.add('column-shadow');
                }
                else {
                    _this.table.classList.remove('column-shadow');
                }
                if (target.scrollTop > 0) {
                    _this.table.classList.add('row-shadow');
                }
                else {
                    _this.table.classList.remove('row-shadow');
                }
                _this.tick = false;
            });
            this.tick = true;
        }
    };
    Object.defineProperty(CsmTable, "is", {
        get: function () { return "csm-table"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTable, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTable, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-table.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTable, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-table.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTable, "elementRef", {
        get: function () { return "table"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTable, "listeners", {
        get: function () {
            return [{
                    "name": "wheel",
                    "method": "trackWheel",
                    "target": undefined,
                    "capture": false,
                    "passive": true
                }, {
                    "name": "scroll",
                    "method": "trackScroll",
                    "target": undefined,
                    "capture": false,
                    "passive": true
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmTable;
}());
var CsmTableCell = /** @class */ (function () {
    function CsmTableCell() {
    }
    CsmTableCell.prototype.render = function () {
        return h("slot", null);
    };
    Object.defineProperty(CsmTableCell, "is", {
        get: function () { return "csm-table-cell"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableCell, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableCell, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-table-cell.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableCell, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-table-cell.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmTableCell;
}());
var CsmTableHeaderCell = /** @class */ (function () {
    function CsmTableHeaderCell() {
        var _this = this;
        this.sortOrder = null;
        this.nosort = null;
        this.disabled = null;
        this.emitSort = function () {
            if (!_this.nosort && !_this.disabled) {
                _this.toggleSorting();
                _this.csmSort.emit(_this.sortOrder);
            }
        };
    }
    CsmTableHeaderCell.prototype.toggleSorting = function () {
        switch (this.sortOrder) {
            case CsmTableSortOrder.ASC: {
                this.sortOrder = CsmTableSortOrder.DESC;
                break;
            }
            case CsmTableSortOrder.DESC: {
                this.sortOrder = CsmTableSortOrder.ASC;
                break;
            }
            default: {
                this.sortOrder = this.defaultSort || CsmTableSortOrder.ASC;
                break;
            }
        }
    };
    CsmTableHeaderCell.prototype.render = function () {
        return (h("div", { class: {
                'csm-table-header-cell': true,
                'csm-table-header-cell--selected': !!this.sortOrder,
                'csm-table-header-cell--disabled': !!this.disabled,
            }, onClick: this.emitSort }, !this.nosort && (h("div", { class: "csm-table-header-cell__sort" }, this.sortOrder === CsmTableSortOrder.ASC && h("csm-icon", { name: "arrow-upward", "size-m": true }), this.sortOrder === CsmTableSortOrder.DESC && h("csm-icon", { name: "arrow-down", "size-m": true }), !this.sortOrder && h("csm-icon", { name: "unfold-more", "size-m": true }))), h("div", { class: "csm-table-header-cell__content" }, h("slot", null))));
    };
    Object.defineProperty(CsmTableHeaderCell, "is", {
        get: function () { return "csm-table-header-cell"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderCell, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderCell, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-table-header-cell.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderCell, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-table-header-cell.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderCell, "properties", {
        get: function () {
            return {
                "sortOrder": {
                    "type": "string",
                    "mutable": true,
                    "complexType": {
                        "original": "CsmTableSortOrder",
                        "resolved": "CsmTableSortOrder.ASC | CsmTableSortOrder.DESC",
                        "references": {
                            "CsmTableSortOrder": {
                                "location": "import",
                                "path": "../../csm-table.constants"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "sort-order",
                    "reflect": true,
                    "defaultValue": "null"
                },
                "nosort": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "nosort",
                    "reflect": false,
                    "defaultValue": "null"
                },
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false,
                    "defaultValue": "null"
                },
                "defaultSort": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "CsmTableSortOrder",
                        "resolved": "CsmTableSortOrder.ASC | CsmTableSortOrder.DESC",
                        "references": {
                            "CsmTableSortOrder": {
                                "location": "import",
                                "path": "../../csm-table.constants"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "default-sort",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderCell, "events", {
        get: function () {
            return [{
                    "method": "csmSort",
                    "name": "csmSort",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "any",
                        "resolved": "any",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmTableHeaderCell;
}());
var CsmTableHeaderRow = /** @class */ (function () {
    function CsmTableHeaderRow() {
    }
    CsmTableHeaderRow.prototype.render = function () {
        return [
            h("div", { class: "csm-table-header-row-content" }, h("slot", null)),
        ];
    };
    Object.defineProperty(CsmTableHeaderRow, "is", {
        get: function () { return "csm-table-header-row"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderRow, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderRow, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-table-header-row.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderRow, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-table-header-row.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableHeaderRow, "elementRef", {
        get: function () { return "tableHeaderRow"; },
        enumerable: true,
        configurable: true
    });
    return CsmTableHeaderRow;
}());
var CsmTableRow = /** @class */ (function () {
    function CsmTableRow() {
    }
    CsmTableRow.prototype.render = function () {
        return h("slot", null);
    };
    Object.defineProperty(CsmTableRow, "is", {
        get: function () { return "csm-table-row"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableRow, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableRow, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-table-row.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTableRow, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-table-row.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmTableRow;
}());
var CsmTabs = /** @class */ (function () {
    function CsmTabs() {
        /**
         * @deprecated
         * Define tab header alignement
         */
        this.alignement = 'left';
        this.tabsChilds = [];
        this.propChangeTrigger = false;
    }
    CsmTabs.prototype.validateAlign = function (newValue, _) {
        var isBlank = typeof newValue == null;
        var invalid = typeof newValue === 'string' && newValue != 'left' && newValue != 'center' && newValue != 'right';
        if (isBlank) {
            throw new Error('align: value required');
        }
        if (invalid) {
            throw new Error('align: invalid entry');
        }
    };
    CsmTabs.prototype.updateTab = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.propChangeTrigger = !this.propChangeTrigger;
                return [2 /*return*/];
            });
        });
    };
    CsmTabs.prototype.componentWillLoad = function () {
        var isSelectedTab = false;
        this.tabsChilds = Array.from(this.element.querySelectorAll('csm-tab')).map(function (el) {
            if (el.selected && isSelectedTab === false) {
                isSelectedTab = true;
                return el;
            }
            if (el.selected && isSelectedTab === true) {
                el.selected = false;
                return el;
            }
            return el;
        });
    };
    CsmTabs.prototype.componentDidLoad = function () {
        this.mounted.emit();
    };
    CsmTabs.prototype.selectTab = function (tab, index) {
        var _this = this;
        this.tabsChilds = this.tabsChilds.map(function (el, i) {
            if (index !== i) {
                el.selected = false;
            }
            else {
                el.selected = true;
                _this.csmTabChange.emit({
                    label: tab.label,
                    index: index,
                });
                var event = new CustomEvent('csmTabSelect', { detail: tab });
                tab.dispatchEvent(event);
            }
            return el;
        });
    };
    CsmTabs.prototype.generateTabsHeader = function () {
        var _this = this;
        return (h("div", { class: 'csm-tab__header csm-tab__header--align-' + this.alignement, part: "csm-tabs-header" }, this.tabsChilds.map(function (tab, i) {
            var customProps = _this.getCustomProps(tab, ['padding-', 'full-width', 'no-uppercase']);
            var dataAttributes = _this.getDataAttrs(tab);
            return (h("csm-tabs-header-cell", Object.assign({}, dataAttributes, customProps, { part: "csm-tabs-header-cell " + tab.label, label: tab.label, icon: tab.icon, id: tab.headerId, selected: tab.selected, disabled: tab.disabled, onClick: !tab.disabled && (function (_) { return _this.selectTab(tab, i); }) })));
        })));
    };
    CsmTabs.prototype.getDataAttrs = function (tab) {
        var dataAttrs = Array.from(tab.attributes).filter(function (a) { return a.name.startsWith('data-'); });
        return dataAttrs.reduce(function (acc, cur) {
            acc[cur.name] = cur.value;
            return acc;
        }, {});
    };
    CsmTabs.prototype.getCustomProps = function (tab, props) {
        var customProps = tab
            .getAttributeNames()
            .filter(function (e) { return props.findIndex(function (p) { return e.startsWith(p); }) > -1; })
            .reduce(function (acc, cur) {
            acc[cur] = true;
            return acc;
        }, {});
        return customProps;
    };
    CsmTabs.prototype.render = function () {
        return (h("div", { class: "csm-tab", part: "csm-tab" }, this.generateTabsHeader(), h("div", { class: "csm-tab__content", part: "csm-tab-content" }, h("slot", null))));
    };
    Object.defineProperty(CsmTabs, "is", {
        get: function () { return "csm-tabs"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-tabs.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-tabs.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "properties", {
        get: function () {
            return {
                "alignement": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "'left' | 'center' | 'right'",
                        "resolved": "\"center\" | \"left\" | \"right\"",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [{
                                "text": "Define tab header alignement",
                                "name": "deprecated"
                            }],
                        "text": ""
                    },
                    "attribute": "alignement",
                    "reflect": false,
                    "defaultValue": "'left'"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "states", {
        get: function () {
            return {
                "tabsChilds": {},
                "propChangeTrigger": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "events", {
        get: function () {
            return [{
                    "method": "csmTabChange",
                    "name": "csmTabChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmTabOnChangeEvent",
                        "resolved": "CsmTabOnChangeEvent",
                        "references": {
                            "CsmTabOnChangeEvent": {
                                "location": "local"
                            }
                        }
                    }
                }, {
                    "method": "mounted",
                    "name": "mounted",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "void",
                        "resolved": "void",
                        "references": {}
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "methods", {
        get: function () {
            return {
                "updateTab": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "",
                        "tags": []
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "elementRef", {
        get: function () { return "element"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabs, "watchers", {
        get: function () {
            return [{
                    "propName": "alignement",
                    "methodName": "validateAlign"
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmTabs;
}());
var CsmTab = /** @class */ (function () {
    function CsmTab() {
    }
    /**
     * Watch for selected and disabled props changes
     */
    CsmTab.prototype.updateParent = function () {
        this.element.parentElement.updateTab();
    };
    CsmTab.prototype.render = function () {
        if (this.selected) {
            return (h(Host, null, h("slot", null)));
        }
    };
    Object.defineProperty(CsmTab, "is", {
        get: function () { return "csm-tab"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTab, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTab, "properties", {
        get: function () {
            return {
                "label": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define tab label"
                    },
                    "attribute": "label",
                    "reflect": false
                },
                "headerId": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define tab header id"
                    },
                    "attribute": "header-id",
                    "reflect": false
                },
                "icon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define csm-material icon to use"
                    },
                    "attribute": "icon",
                    "reflect": false
                },
                "selected": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define if tab is selected"
                    },
                    "attribute": "selected",
                    "reflect": false
                },
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define if tab is disabled"
                    },
                    "attribute": "disabled",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTab, "events", {
        get: function () {
            return [{
                    "method": "csmTabSelect",
                    "name": "csmTabSelect",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "CsmTab",
                        "resolved": "CsmTab",
                        "references": {
                            "CsmTab": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTab, "elementRef", {
        get: function () { return "element"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTab, "watchers", {
        get: function () {
            return [{
                    "propName": "selected",
                    "methodName": "updateParent"
                }, {
                    "propName": "disabled",
                    "methodName": "updateParent"
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmTab;
}());
var CsmTabHeaderCell = /** @class */ (function () {
    function CsmTabHeaderCell() {
    }
    CsmTabHeaderCell.prototype.render = function () {
        return (h(Host, { class: {
                selected: this.selected,
                disabled: this.disabled,
            } }, this.icon && h("csm-icon", { name: this.icon }), h("csm-label", null, this.label)));
    };
    Object.defineProperty(CsmTabHeaderCell, "is", {
        get: function () { return "csm-tabs-header-cell"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabHeaderCell, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabHeaderCell, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-tab-header-cell.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabHeaderCell, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-tab-header-cell.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTabHeaderCell, "properties", {
        get: function () {
            return {
                "label": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define tab label"
                    },
                    "attribute": "label",
                    "reflect": false
                },
                "icon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define csm-material icon to use"
                    },
                    "attribute": "icon",
                    "reflect": false
                },
                "selected": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define if tab is selected"
                    },
                    "attribute": "selected",
                    "reflect": false
                },
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Define if tab is disabled"
                    },
                    "attribute": "disabled",
                    "reflect": false
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmTabHeaderCell;
}());
// const EVENT_LISTENER_SYMBOL = Symbol('EVENT_LISTENER_SYMBOL');
var CsmTextfield = /** @class */ (function () {
    function CsmTextfield() {
        this.value = '';
        this.oldValue = '';
        console.warn('CSM-TEXTFIELD HAS BEEN DEPRECATED IN FAVOR OF CSM-INPUT');
        this.focusInput = this.focusInput.bind(this);
    }
    CsmTextfield.prototype.focusInput = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.textInput.focus();
                return [2 /*return*/];
            });
        });
    };
    CsmTextfield.prototype.onChange = function (event, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var input;
            return __generator(this, function (_c) {
                if (force || event.target.value !== this.oldValue) {
                    this.oldValue = this.value = event.target.value;
                    this.csmChange.emit(this.value);
                }
                input = this.host.querySelector('input');
                (input || this.host).blur();
                this.csmBlur.emit(event);
                return [2 /*return*/];
            });
        });
    };
    CsmTextfield.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isMoveKeys = keyCode === 8 || keyCode === 9 || keyCode === 37 || keyCode === 39 || keyCode === 46; // Delete, Tab, Left, Right, Back delete
        if (this.type === TextfieldType.Number && !isMoveKeys && !+event.key && +event.key !== 0) {
            event.preventDefault();
            event.cancelBubble = true;
            return;
        }
        this.csmKeydown.emit(event);
    };
    CsmTextfield.prototype.onKeyUp = function (event) {
        if (event.code === 'Enter' || event.key === 'Enter') {
            this.onChange(event, true);
            return;
        }
        if (this.type === TextfieldType.Number &&
            !+event.key &&
            +event.key !== 0 &&
            event.code !== 'Backspace' &&
            event.code !== 'Delete' &&
            !event.key.startsWith('Arrow')) {
            event.preventDefault();
            event.cancelBubble = true;
            return;
        }
        event.value = event.target.value;
        this.host.setAttribute('value', event.target.value);
        this.csmKeyup.emit(event);
    };
    CsmTextfield.prototype.onIconClick = function (event, which) {
        var iconElement = event.path.find(function (i) { return i.tagName === 'CSM-ICON'; });
        this.csmIconClick.emit({ which: which, iconElement: iconElement });
    };
    CsmTextfield.prototype.onFocus = function (event) {
        this.csmFocus.emit(event);
    };
    CsmTextfield.prototype.componentWillLoad = function () {
        var nameAttr = this.host.attributes.getNamedItem('name');
        if (nameAttr) {
            this.host.attributes.removeNamedItem('name');
            this.name = nameAttr.value;
        }
    };
    CsmTextfield.prototype.render = function () {
        var _this = this;
        var inputType = this.type === TextfieldType.Number ? TextfieldType.Text : this.type;
        var ret = [];
        ret.push(h("input", Object.assign({ name: this.name, class: "csm-textfield__input", part: "textfield-input", placeholder: this.placeholder, type: inputType, value: this.value, onKeyDown: function (event) { return _this.onKeyDown(event); }, onKeyUp: function (event) { return _this.onKeyUp(event); }, onBlur: function (event) { return _this.onChange(event); }, onFocus: function (event) { return _this.onFocus(event); } }, { disabled: this.disabled }, { ref: function (el) { return (_this.textInput = el); } })));
        if (this.leftIcon && this.leftIcon.length) {
            ret.push(h("csm-icon", { class: 'csm-textfield__icon csm-textfield__icon-left' + (this.clickableIcon ? ' clickable' : ''), "size-m": true, name: this.leftIcon, onClick: function (e) { return _this.onIconClick(e, 'left'); }, part: "textfield-icon" }));
        }
        if (this.rightIcon && this.rightIcon.length) {
            ret.push(h("csm-icon", { class: 'csm-textfield__icon csm-textfield__icon-right' + (this.clickableIcon ? ' clickable' : ''), "size-m": true, name: this.rightIcon, onClick: function (e) { return _this.onIconClick(e, 'right'); } }));
        }
        return ret;
    };
    // @ts-ignore
    CsmTextfield.prototype.componentShouldUpdate = function (newVal, oldVal, propName) {
        if (!newVal) {
            return true;
        }
        return !(oldVal === newVal && propName === 'value');
    };
    Object.defineProperty(CsmTextfield, "is", {
        get: function () { return "csm-textfield"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-textfield.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-textfield.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "properties", {
        get: function () {
            return {
                "disabled": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "disabled",
                    "reflect": false
                },
                "clickableIcon": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "clickable-icon",
                    "reflect": false
                },
                "type": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "TextfieldType",
                        "resolved": "TextfieldType.Email | TextfieldType.Number | TextfieldType.Password | TextfieldType.Text",
                        "references": {
                            "TextfieldType": {
                                "location": "import",
                                "path": "./textfield.type"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "type",
                    "reflect": false
                },
                "placeholder": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "placeholder",
                    "reflect": false
                },
                "leftIcon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "left-icon",
                    "reflect": false
                },
                "rightIcon": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "right-icon",
                    "reflect": false
                },
                "value": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "value",
                    "reflect": false,
                    "defaultValue": "''"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "events", {
        get: function () {
            return [{
                    "method": "csmChange",
                    "name": "csmChange",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "string",
                        "resolved": "string",
                        "references": {}
                    }
                }, {
                    "method": "csmIconClick",
                    "name": "csmIconClick",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "{ which: 'left' | 'right'; iconElement: HTMLCsmIconElement }",
                        "resolved": "{ which: \"left\" | \"right\"; iconElement: any; }",
                        "references": {
                            "HTMLCsmIconElement": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmKeydown",
                    "name": "csmKeydown",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "KeyboardEvent",
                        "resolved": "KeyboardEvent",
                        "references": {
                            "KeyboardEvent": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmKeyup",
                    "name": "csmKeyup",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "KeyboardEvent",
                        "resolved": "KeyboardEvent",
                        "references": {
                            "KeyboardEvent": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmFocus",
                    "name": "csmFocus",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "FocusEvent",
                        "resolved": "FocusEvent",
                        "references": {
                            "FocusEvent": {
                                "location": "global"
                            }
                        }
                    }
                }, {
                    "method": "csmBlur",
                    "name": "csmBlur",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "complexType": {
                        "original": "FocusEvent",
                        "resolved": "FocusEvent",
                        "references": {
                            "FocusEvent": {
                                "location": "global"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "methods", {
        get: function () {
            return {
                "focusInput": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "",
                        "tags": []
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTextfield, "elementRef", {
        get: function () { return "host"; },
        enumerable: true,
        configurable: true
    });
    return CsmTextfield;
}());
var CsmToast = /** @class */ (function () {
    function CsmToast() {
        /**
         * Set the display time of the toast (in milliseconde)
         */
        this.timeout = 10000;
        /**
         * Set the level of severity for the toast
         * default value 'info'
         * possible value 'error', 'warning', 'success', 'info'
         */
        this.severity = CsmToastSeverity.Info;
        /**
         * Set to true to not have display none when hidden
         */
        this.disableHide = false;
        /**
         * Set to true to reset the timeout when the user hovers on the element
         */
        this.pauseOnHover = false;
        /**
         * Set to true to display the close icone inside the toast
         */
        this.displayCloseIcon = true;
        /**
         * Reflects the state of the toast.
         */
        this.showToast = false;
    }
    /**
     * Display the toast. <br/>
     * The method is async, but you can safely ignore the promise.
     */
    CsmToast.prototype.open = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                clearTimeout(this.setTimeoutRef);
                this.showToast = true;
                this.startCount();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Close the toast. <br/>
     * The method is async, but you can safely ignore the promise.
     */
    CsmToast.prototype.close = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                this.closeToast(CsmToastClosingType.ByCloseMethod);
                return [2 /*return*/];
            });
        });
    };
    CsmToast.prototype.closeToast = function (closeBy) {
        this.clearTimeout();
        this.showToast = false;
        this.csmClose.emit(closeBy);
    };
    CsmToast.prototype.startCount = function () {
        var _this = this;
        this.setTimeoutRef = setTimeout(function () {
            _this.closeToast(CsmToastClosingType.ByTimeout);
        }, this.timeout);
    };
    CsmToast.prototype.clearTimeout = function () {
        clearTimeout(this.setTimeoutRef);
    };
    CsmToast.prototype.onMouseEnter = function () {
        if (!this.pauseOnHover) {
            return;
        }
        this.clearTimeout();
    };
    CsmToast.prototype.onMouseLeave = function () {
        if (!this.pauseOnHover) {
            return;
        }
        this.startCount();
    };
    CsmToast.prototype.render = function () {
        var _this = this;
        return (h("div", { class: { toast: true, 'toast--open': this.disableHide || this.showToast }, onMouseEnter: function () { return _this.onMouseEnter(); }, onMouseLeave: function () { return _this.onMouseLeave(); } }, h("div", { class: "toast__container" }, h("div", { class: "toast__block", "data-severity": this.severity }), h("div", { class: "toast__content" }, h("slot", null))), this.displayCloseIcon && (h("csm-icon", { class: "toast__close-button", name: "close", onClick: function () { return _this.closeToast(CsmToastClosingType.ByUser); } }))));
    };
    Object.defineProperty(CsmToast, "is", {
        get: function () { return "csm-toast"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-toast.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-toast.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "properties", {
        get: function () {
            return {
                "timeout": {
                    "type": "number",
                    "mutable": false,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Set the display time of the toast (in milliseconde)"
                    },
                    "attribute": "timeout",
                    "reflect": true,
                    "defaultValue": "10000"
                },
                "severity": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "CsmToastSeverity",
                        "resolved": "CsmToastSeverity.Error | CsmToastSeverity.Info | CsmToastSeverity.Success | CsmToastSeverity.Warning",
                        "references": {
                            "CsmToastSeverity": {
                                "location": "import",
                                "path": "./csm-toast.constants"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Set the level of severity for the toast\ndefault value 'info'\npossible value 'error', 'warning', 'success', 'info'"
                    },
                    "attribute": "severity",
                    "reflect": true,
                    "defaultValue": "CsmToastSeverity.Info"
                },
                "disableHide": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Set to true to not have display none when hidden"
                    },
                    "attribute": "disable-hide",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "pauseOnHover": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": "Set to true to reset the timeout when the user hovers on the element"
                    },
                    "attribute": "pause-on-hover",
                    "reflect": true,
                    "defaultValue": "false"
                },
                "displayCloseIcon": {
                    "type": "boolean",
                    "mutable": false,
                    "complexType": {
                        "original": "boolean",
                        "resolved": "boolean",
                        "references": {}
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": "Set to true to display the close icone inside the toast"
                    },
                    "attribute": "display-close-icon",
                    "reflect": false,
                    "defaultValue": "true"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "states", {
        get: function () {
            return {
                "showToast": {}
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "events", {
        get: function () {
            return [{
                    "method": "csmClose",
                    "name": "csmClose",
                    "bubbles": true,
                    "cancelable": true,
                    "composed": true,
                    "docs": {
                        "tags": [],
                        "text": "Sent whenever the toast is closed through its `close()` method, the parameter indicates how the toast has been closed"
                    },
                    "complexType": {
                        "original": "CsmToastClosingType",
                        "resolved": "CsmToastClosingType.ByCloseMethod | CsmToastClosingType.ByTimeout | CsmToastClosingType.ByUser",
                        "references": {
                            "CsmToastClosingType": {
                                "location": "import",
                                "path": "./csm-toast.constants"
                            }
                        }
                    }
                }];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "methods", {
        get: function () {
            return {
                "open": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "Display the toast. <br/>\nThe method is async, but you can safely ignore the promise.",
                        "tags": []
                    }
                },
                "close": {
                    "complexType": {
                        "signature": "() => Promise<void>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<void>"
                    },
                    "docs": {
                        "text": "Close the toast. <br/>\nThe method is async, but you can safely ignore the promise.",
                        "tags": []
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmToast, "elementRef", {
        get: function () { return "toast"; },
        enumerable: true,
        configurable: true
    });
    return CsmToast;
}());
var CsmTooltip = /** @class */ (function () {
    function CsmTooltip() {
        this.position = Position.TOP;
        this.boxContainer = window;
        this.delay = 200;
        this.tooltipId = UuidService.v4();
    }
    CsmTooltip.prototype.getTooltipId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, this.tooltipId];
            });
        });
    };
    CsmTooltip.prototype.getTooltipRef = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_c) {
                return [2 /*return*/, this.contentRef];
            });
        });
    };
    CsmTooltip.prototype.disconnectedCallback = function () {
        var _a;
        (_a = this.contentRef) === null || _a === void 0 ? void 0 : _a.remove();
    };
    CsmTooltip.prototype.componentDidLoad = function () {
        var _this = this;
        if (!this.parentReference) {
            this.parentReference = this.tooltip.parentElement;
        }
        this.parentReference.onmouseenter = function () {
            _this.renderTooltipContent();
            document.body.appendChild(_this.contentRef);
        };
        this.parentReference.onmouseleave = function () {
            var _a;
            (_a = _this.positionHandler) === null || _a === void 0 ? void 0 : _a.onMouseLeave();
            document.body.removeChild(_this.contentRef);
        };
    };
    CsmTooltip.prototype.componentDidUnload = function () {
        var _a;
        (_a = this.positionHandler) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    CsmTooltip.prototype.renderTooltipContent = function () {
        var tooltipContentElement = document.createElement('csm-tooltip-content');
        tooltipContentElement.style.position = 'absolute';
        tooltipContentElement.style.width = '0';
        tooltipContentElement.style.height = '0';
        tooltipContentElement.className = this.tooltip.className;
        this.contentRef = tooltipContentElement;
        this.contentRef.setAttribute('tooltip-id', this.tooltipId);
        var childNodes = this.tooltip.childNodes;
        for (var i = 0; i < childNodes.length; i++) {
            this.contentRef.append(childNodes.item(i).cloneNode(true));
        }
    };
    CsmTooltip.prototype.onTooltipLoaded = function (event) {
        if (event.detail === this.tooltipId) {
            this.positionHandler = new PositionHandler(this.contentRef.querySelector('.csm-tooltip'), this.parentReference, this.boxContainer, this.position, this.delay);
            this.positionHandler.onMouseEnter();
        }
    };
    CsmTooltip.prototype.render = function () {
        return (h(Host, { "data-tooltip-id": this.tooltipId }, h("div", { class: "hidden" }, h("slot", null))));
    };
    Object.defineProperty(CsmTooltip, "is", {
        get: function () { return "csm-tooltip"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTooltip, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTooltip, "styles", {
        get: function () { return ".hidden { display: none; }"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTooltip, "properties", {
        get: function () {
            return {
                "position": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "Position",
                        "resolved": "Position.BOTTOM | Position.LEFT | Position.RIGHT | Position.TOP",
                        "references": {
                            "Position": {
                                "location": "import",
                                "path": "../utils/position-handler"
                            }
                        }
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "position",
                    "reflect": false,
                    "defaultValue": "Position.TOP"
                },
                "parentReference": {
                    "type": "unknown",
                    "mutable": false,
                    "complexType": {
                        "original": "HTMLElement",
                        "resolved": "HTMLElement",
                        "references": {
                            "HTMLElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    }
                },
                "boxContainer": {
                    "type": "unknown",
                    "mutable": false,
                    "complexType": {
                        "original": "Window | HTMLElement",
                        "resolved": "HTMLElement | Window",
                        "references": {
                            "Window": {
                                "location": "global"
                            },
                            "HTMLElement": {
                                "location": "global"
                            }
                        }
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "defaultValue": "window"
                },
                "delay": {
                    "type": "number",
                    "mutable": false,
                    "complexType": {
                        "original": "number",
                        "resolved": "number",
                        "references": {}
                    },
                    "required": false,
                    "optional": false,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "delay",
                    "reflect": false,
                    "defaultValue": "200"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTooltip, "methods", {
        get: function () {
            return {
                "getTooltipId": {
                    "complexType": {
                        "signature": "() => Promise<string>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<string>"
                    },
                    "docs": {
                        "text": "",
                        "tags": []
                    }
                },
                "getTooltipRef": {
                    "complexType": {
                        "signature": "() => Promise<any>",
                        "parameters": [],
                        "references": {
                            "Promise": {
                                "location": "global"
                            }
                        },
                        "return": "Promise<any>"
                    },
                    "docs": {
                        "text": "",
                        "tags": []
                    }
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTooltip, "elementRef", {
        get: function () { return "tooltip"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTooltip, "listeners", {
        get: function () {
            return [{
                    "name": "csmTooltipContentLoaded",
                    "method": "onTooltipLoaded",
                    "target": "body",
                    "capture": false,
                    "passive": false
                }];
        },
        enumerable: true,
        configurable: true
    });
    return CsmTooltip;
}());
var CsmSpinner = /** @class */ (function () {
    function CsmSpinner() {
        this.size = SpinnerSize.Medium;
    }
    CsmSpinner.prototype.render = function () {
        var stroke;
        var radius;
        switch (this.size) {
            case SpinnerSize.Large:
                stroke = 7.5;
                radius = 24;
                break;
            case SpinnerSize.Medium:
                stroke = 5;
                radius = 16;
                break;
            case SpinnerSize.Small:
            default:
                stroke = 2.5;
                radius = 8;
        }
        var diameter = radius * 2;
        var circumference = diameter * Math.PI;
        var centerPoint = radius + stroke / 2;
        var progressDash = circumference * 0.66;
        return (h(Host, null, h("svg", { class: "spinner", width: diameter + "px", height: diameter + "px", viewBox: "0 0 " + (diameter + stroke) + " " + (diameter + stroke), preserveAspectRatio: "xMidYMid" }, h("circle", { class: "back-circle", cx: centerPoint, cy: centerPoint, "stroke-width": stroke, r: radius }), h("circle", { class: "front-circle", cx: centerPoint, cy: centerPoint, "stroke-width": stroke, r: radius, "stroke-dasharray": progressDash + " " + circumference, transform: "rotate(" + -90 + " " + centerPoint + " " + centerPoint + ")" }, h("animateTransform", { attributeName: "transform", type: "rotate", repeatCount: "indefinite", dur: "1.5s", values: "0 " + centerPoint + " " + centerPoint + ";360 " + centerPoint + " " + centerPoint, keyTimes: "0;1" })))));
    };
    Object.defineProperty(CsmSpinner, "is", {
        get: function () { return "csm-spinner"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSpinner, "encapsulation", {
        get: function () { return "shadow"; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSpinner, "originalStyleUrls", {
        get: function () {
            return {
                "$": ["csm-spinner.scss"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSpinner, "styleUrls", {
        get: function () {
            return {
                "$": ["csm-spinner.css"]
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmSpinner, "properties", {
        get: function () {
            return {
                "size": {
                    "type": "string",
                    "mutable": false,
                    "complexType": {
                        "original": "SpinnerSize",
                        "resolved": "SpinnerSize.Large | SpinnerSize.Medium | SpinnerSize.Small",
                        "references": {
                            "SpinnerSize": {
                                "location": "import",
                                "path": "./csm-spinner.constants"
                            }
                        }
                    },
                    "required": false,
                    "optional": true,
                    "docs": {
                        "tags": [],
                        "text": ""
                    },
                    "attribute": "size",
                    "reflect": false,
                    "defaultValue": "SpinnerSize.Medium"
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmSpinner;
}());
export { CsmActionItem, CsmActionList, CsmButton, CsmCheckbox, CsmCollapsible, CsmDropDownList, CsmDroppableArea, CsmIcon, CsmInput, CsmIntersectAnchor, CsmLabel, CsmPagination, CsmPanel, CsmPill, CsmRangeSlider, CsmSelect, CsmSelectCategory, CsmSelectDivider, CsmSelectItem, CsmSortableItem, CsmSortableList, CsmSortableListDemo, CsmSpinner, CsmSwitcher, CsmSwitcherButton, CsmSwitcherOption, CsmTab, CsmTabHeaderCell, CsmTable, CsmTableCell, CsmTableHeaderCell, CsmTableHeaderRow, CsmTableRow, CsmTabs, CsmTextfield, CsmToast, CsmTooltip };
